LazyLoad = (function(){
	function init(settings){
		if(!!settings && settings == 'scroll') window.addEventListener('scroll',throttle(lazyload,500,1000));
		lazyload(settings);
	}

	function lazyload(settings) {
		$(".lazyload").each(function(){
			var $div = $(this);
			if(!$div.hasClass("loaded")){
				// bind to scroll event
				if(!!settings && settings == 'scroll'){
					if ($div.offset().top < parseInt($(window).height()) + parseInt($(window).scrollTop())) {
						if(!!$div.attr("data-src")) $div.attr("src",$div.attr("data-src"));
						if(!!$div.attr("data-background-image")) $div.css('background-image', $div.attr("data-background-image"));
 						$div.addClass("loaded");
					}
				}
				// load directly
				else {
						if(!!$div.attr("data-src")) $div.attr("src",$div.attr("data-src"));
						if(!!$div.attr("data-background-image")) $div.css('background-image', $div.attr("data-background-image"));
 						$div.addClass("loaded");
				}
			}
		});
    }

    function throttle(fun, delay, time) {
    	var timeout,
    	startTime = new Date();

    	return function() {
    		var context = this,
    		args = arguments,
    		curTime = new Date();

    		clearTimeout(timeout);
    		if (curTime - startTime >= time) {
    			fun.apply(context, args);
    			startTime = curTime;
    		} else {
    			timeout = setTimeout(fun, delay);
    		}
    	};
    }

	return {
		init: init,
		throttle: throttle
	}
})();